import { render } from "./subject.vue?vue&type=template&id=07b6f0d3&ts=true"
import script from "./subject.vue?vue&type=script&lang=ts"
export * from "./subject.vue?vue&type=script&lang=ts"

import "./subject.vue?vue&type=style&index=0&id=07b6f0d3&lang=css"

import exportComponent from "/home/devadm/tuyensinh-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__